import type { LocaleGroupFields } from '@tribeplatform/gql-client/graphql'
import type {
  LocaleGroup,
  QueryLocaleGroupArgs,
} from '@tribeplatform/gql-client/types'

import { useQuery, UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getLocaleGroupKey } from '../../utils/keys/localeGroup.key.js'

export const useLocaleGroup = (options: {
  variables: QueryLocaleGroupArgs
  fields?: LocaleGroupFields
  useQueryOptions?: UseQueryOptions<LocaleGroup>
}) => {
  const { variables, fields = 'default', useQueryOptions } = options
  const { client } = useTribeClient()
  const localeGroupKey = getLocaleGroupKey({ variables, fields })

  return useQuery<LocaleGroup>(
    localeGroupKey,
    () => client.localeGroups.get(variables, fields),
    useQueryOptions,
  )
}
